import { size, trim } from "lodash";

export default function isSearchStringValid(searchString, minLength = 3, maxLength) {
  const inputLength = size(trim(searchString));

  if (maxLength !== undefined) {
    return inputLength >= minLength && inputLength <= maxLength;
  }

  return inputLength >= minLength;
}
